import invalidateVisCache from 'api/invalidateVisCache';
import STORE from 'store';

const updateStoreVisualisation = async ({
  accountId,
  reportGadgetId,
  updatedChartDef,
}: {
  accountId: string;
  reportGadgetId: string;
  updatedChartDef: VisualisationDefinition;
}) => {
  await STORE.visualisations
    .getReportGadgetsRef({ accountId })
    .doc(reportGadgetId)
    .update({ chartDef: updatedChartDef });

  await invalidateVisCache({
    accountId,
    changes: { reportGadgets: [reportGadgetId] },
  });
};

export default updateStoreVisualisation;
